/**
 * Business defaults flat region for Engine Editor — substrate × calculation
 * cell (flat-regions mode, 1 of 3 vertically stacked) per scope-doc §2
 * cell-by-cell routing.
 *
 * Sub-shape 4b-deferred (admin / specialized-surface, V2-promotion-named).
 * `params` business-level rows live primarily at Settings → Params & Defaults
 * through V1. V2 promotion criterion: Day 88 CF 64 substrate-gate per
 * scope-doc §4.2 line 568.
 *
 * Engine Editor renders sub-shape 4b-deferred negative affordance per
 * scope-doc §4.2 lines 558-564 verbatim copy framing pattern.
 */

import type { JSX } from 'react';
import { Settings as SettingsIcon } from 'lucide-react';
import { URL_SETTINGS_PARAMS } from '../../../lib/engine-editor/engineEditorUrls';

export default function EngineEditorBusinessDefaults(): JSX.Element {
  return (
    <section
      id="business-defaults"
      data-cell-coordinate="substrate-calculation"
      data-region-type="region"
      className="border border-border bg-surface-1 rounded-lg p-4 space-y-3"
    >
      <div className="flex items-start gap-2">
        <SettingsIcon size={16} className="text-ink-secondary flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h2 className="text-sm font-semibold text-ink-bright">Business defaults</h2>
          <p className="text-xs text-ink-secondary mt-1">
            Business-level params shaping engine inputs across all entities.
          </p>
        </div>
      </div>

      {/* COMPOSABILITY: per-section "Last changed X days ago" indicator slot — wires post-Day 92 */}

      <p className="text-xs text-ink-muted italic pt-2 border-t border-border-subtle">
        Edit at{' '}
        <a
          href={URL_SETTINGS_PARAMS}
          className="text-accent hover:underline not-italic"
        >
          Settings → Params &amp; Defaults
        </a>
        . Engine Editor absorbs at V2 (Day 88 CF 64 substrate-gate).
      </p>
    </section>
  );
}
